import quickFetch from 'quick-fetch';
import I18n from 'I18n';
import partial from 'transmute/partial';
import { createRequestAction } from 'MeetingsBase/utils/actions';
import { createSuccessNotificationMeta, createDangerNotificationMeta } from 'MeetingsAdmin/utils/actions';
import { cleanSlug } from 'MeetingsAdmin/utils/utils';
import * as ActionTypes from 'MeetingsAdmin/redux/actions/ActionTypes';
import { List } from 'immutable';
import { fetchMeetingsLinkByIdInfo, fetchMeetingsLinkBySlug, fetchMeetingsLinkInfo, fetchBaseUrl as fetchBaseUrlRequest, createMeetingsLinkForUser as createMeetingsLinkForUserRequest, createMeetingsLink as createMeetingsLinkRequest, updateMeetingsLink as updateMeetingsLinkRequest, deleteMeetingsLink as deleteMeetingsLinkRequest, deleteMeetingsLinkForUser as deleteMeetingsLinkForUserRequest, checkLinkSlug as checkLinkSlugRequest, updateMeetingsLinkForUser as updateMeetingsLinkForUserRequest, transferMeetingsLink as transferMeetingsLinkRequest } from 'MeetingsAdmin/api/meetingsLinkAPI';
import CustomReminderEmail from 'MeetingsBase/models/CustomReminderEmail';
import MeetingsLink from 'MeetingsBase/models/MeetingsLink';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { fetchLinkStats } from 'MeetingsAdmin/redux/actions/LinkStatsActions';
import * as MeetingsCustomEmailActions from 'MeetingsAdmin/redux/actions/MeetingsCustomEmailActions';
import Raven from 'raven-js';
import { LINK_OWNER_UPDATE_ERROR, PERSONAL_LINK_CREATE_ERROR, FORBIDDEN_ERROR_CODE, VCE_ACCOUNT_ID_ERROR } from '../../constants/errors';
import { getHasStarterFeatureAccess
// @ts-expect-error untyped import
} from '../../selectors/AccessSelector';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '../.... Remove this comment to see the full error message
import { getUserId } from '../../selectors/AuthSelector';
import UsageTracker from 'MeetingsAdmin/tracking/UsageTracker';
import { buildDefaultReminderEmail } from 'MeetingsAdmin/utils/email';
import { getEditingLinkOwnerName } from '../../selectors/EditMeetingsLinkSelector';
import { setMeetingsLinkIgnoredPropertiesMap, resetMeetingsLinkIgnoredPropertiesMap
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Meet... Remove this comment to see the full error message
} from 'MeetingsAdmin/redux/actions/EditActions';
import { jsx as _jsx } from "react/jsx-runtime";
const fetchWithEarlyRequestHook = (fallbackFetch, requestName) => {
  const earlyRequest = quickFetch.getRequestStateByName(requestName);
  if (earlyRequest) {
    return new Promise((resolve, reject) => {
      earlyRequest.whenFinished((...args) => {
        resolve(...args);
        quickFetch.removeEarlyRequest(requestName);
      });
      earlyRequest.onError((req, message) => {
        reject(new Error(message, {
          cause: req
        }));
        quickFetch.removeEarlyRequest(requestName);
      });
    });
  }
  return fallbackFetch();
};
function getMeetingsLink(state) {
  const linkJS = state.linkBeingEdited.staged.convertToJSON();
  if (!linkJS.customParams.timezone) {
    Raven.captureMessage('Saving invalid timezone to link', {
      extra: {
        meetingsLinkData: linkJS
      }
    });
  }
  return linkJS;
}
function getMeetingsLinkAssociatedSettings(state) {
  const associatedSettingsJS = state.linkBeingEdited.linkAssociatedSettings.convertToJSON();
  return associatedSettingsJS;
}
export const requestedMeetingsLinkById = createRequestAction(ActionTypes.MEETINGS_LINK_FETCH_BY_ID_STARTED);
export const receivedMeetingsLinkDataById = createRequestAction(ActionTypes.MEETINGS_LINK_FETCH_BY_ID_SUCCEEDED, meetingsLinkData => {
  return MeetingsLink.fromId(meetingsLinkData);
});
export const requestedMeetingsLinkByIdFailed = createRequestAction(ActionTypes.MEETINGS_LINK_FETCH_BY_ID_FAILED, (error, props) => ({
  error,
  props
}));
export const fetchBaseUrlAction = createRequestAction(ActionTypes.BASE_URL_FETCH_STARTED);
export const fetchBaseUrlSucceeded = createRequestAction(ActionTypes.BASE_URL_FETCH_SUCCEEDED, urlInfo => ({
  urlInfo
}));
export const fetchBaseUrlFailed = createRequestAction(ActionTypes.BASE_URL_FETCH_FAILED, error => ({
  error
}));
export function fetchBaseUrl() {
  return dispatch => {
    dispatch(fetchBaseUrlAction());
    return fetchBaseUrlRequest().then(urlInfo => {
      dispatch(fetchBaseUrlSucceeded(urlInfo));
    }, error => {
      dispatch(fetchBaseUrlFailed(error));
    });
  };
}
export const requestedMeetingsLink = createRequestAction(ActionTypes.MEETINGS_LINKS_FETCH_STARTED);
export const receivedMeetingsLinkData = createRequestAction(ActionTypes.MEETINGS_LINKS_FETCH_SUCCEEDED, meetingsLinkData => {
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'unknown' is not assignable to pa... Remove this comment to see the full error message
  return List(meetingsLinkData).map(ml => MeetingsLink.from(ml));
});
export const requestedMeetingsLinkFailed = createRequestAction(ActionTypes.MEETINGS_LINKS_FETCH_FAILED, error => ({
  error
}));
const meetingsLinkFetchSucceeded = meetingsLinkData => dispatch => {
  dispatch(receivedMeetingsLinkData(meetingsLinkData));
  const linkIds = List(meetingsLinkData).reduce((listOfIds, link) => listOfIds.push(link.id), List());
  dispatch(fetchLinkStats(linkIds.toJS()));
};
const meetingsLinkFetchFailed = error => dispatch => dispatch(requestedMeetingsLinkFailed(error));
export function initialFetchMeetingsLinks() {
  return dispatch => {
    dispatch(requestedMeetingsLink());
    return fetchWithEarlyRequestHook(
    // @ts-expect-error ts-migrate(2554) FIXME: Expected 1 arguments, but got 0.
    () => fetchMeetingsLinkInfo(), 'meetings-links').then(response => dispatch(meetingsLinkFetchSucceeded(response)), error => dispatch(meetingsLinkFetchFailed(error)));
  };
}
export function fetchMeetingsLinks(userId) {
  return (dispatch, getState) => {
    if (userId === getUserId(getState())) {
      // By setting userId null, we fetch associated links for the current user
      userId = null;
    }
    dispatch(requestedMeetingsLink(userId));
    return fetchMeetingsLinkInfo(userId).then(response => dispatch(meetingsLinkFetchSucceeded(response)), error => dispatch(meetingsLinkFetchFailed(error)));
  };
}
export function fetchMeetingsLinkById(id) {
  return dispatch => {
    dispatch(requestedMeetingsLinkById());
    return fetchMeetingsLinkByIdInfo(id).then(meetingsLinkData => {
      dispatch(receivedMeetingsLinkDataById(meetingsLinkData));
      dispatch(resetMeetingsLinkIgnoredPropertiesMap());
      return meetingsLinkData;
    }, error => {
      dispatch(requestedMeetingsLinkByIdFailed(error, {
        id
      }));
      throw error;
    });
  };
}
export const createMeetingsLinkAction = createRequestAction(ActionTypes.MEETINGS_LINK_CREATE_STARTED);
export const createMeetingsLinkSucceeded = createRequestAction(ActionTypes.MEETINGS_LINK_CREATE_SUCCEEDED, response => MeetingsLink.fromId(response));
export const createMeetingsLinkFailed = createRequestAction(ActionTypes.MEETINGS_LINK_CREATE_FAILED, error => ({
  error
}), error => {
  if (error.status === FORBIDDEN_ERROR_CODE) {
    return createDangerNotificationMeta(I18n.text('notifications.createLinkPermissionError', {
      failedReason: error.responseJSON.message
    }));
  }
  return createDangerNotificationMeta(I18n.text('notifications.createLinkError'));
});
export function createMeetingsLink(forOtherUser) {
  return (dispatch, getState) => {
    dispatch(createMeetingsLinkAction());
    const state = getState();
    const meetingsLink = getMeetingsLink(state);
    const createLinkRequest = forOtherUser ? createMeetingsLinkForUserRequest : createMeetingsLinkRequest;
    delete meetingsLink.id;
    return createLinkRequest(meetingsLink).then(response => {
      dispatch(createMeetingsLinkSucceeded(response));
      return response;
    }, error => {
      dispatch(createMeetingsLinkFailed(error));
      throw error;
    });
  };
}
export function createMeetingsLinkV2(forOtherUser) {
  return async (dispatch, getState) => {
    dispatch(createMeetingsLinkAction());
    const state = getState();
    const hasStarterFeatureAccess = getHasStarterFeatureAccess(state);
    const meetingsLink = getMeetingsLink(state);
    const meetingsLinkAssociatedSettings = getMeetingsLinkAssociatedSettings(state).current;
    const meetingsLinkSlug = meetingsLink.slug;
    const createLinkRequest = forOtherUser ? createMeetingsLinkForUserRequest : createMeetingsLinkRequest;
    delete meetingsLink.id;
    let meetingsLinkExists = false;
    let meetingsLinkResponse = null;
    try {
      const response = await fetchMeetingsLinkBySlug(meetingsLinkSlug);
      meetingsLinkExists = true;
      meetingsLinkResponse = response;
    } catch (error) {
      if (!error.message.includes('404')) {
        dispatch(createMeetingsLinkFailed(error));
        throw error;
      }
    }
    if (!meetingsLinkExists) {
      try {
        const response = await createLinkRequest(meetingsLink);
        meetingsLinkResponse = response;
      } catch (error) {
        dispatch(createMeetingsLinkFailed(error));
        throw error;
      }
    }
    const meetingsLinkId = meetingsLinkResponse.id;
    const {
      customReminderEmail
    } = meetingsLinkAssociatedSettings;
    const includeDescriptionInNewLink = false;
    const hasChangesToDefaultReminderEmail = !CustomReminderEmail.equalsJSON(customReminderEmail, buildDefaultReminderEmail(includeDescriptionInNewLink));
    const isUpdatingCustomMeetingReminders = hasStarterFeatureAccess && hasChangesToDefaultReminderEmail && !!(customReminderEmail.body && customReminderEmail.subject);
    if (isUpdatingCustomMeetingReminders) {
      try {
        await MeetingsCustomEmailActions.putCustomReminderEmail(meetingsLinkId, customReminderEmail)(dispatch);
      } catch (error) {
        dispatch(createMeetingsLinkFailed(error));
        throw error;
      }
    }
    dispatch(createMeetingsLinkSucceeded(meetingsLinkResponse));
    return meetingsLinkResponse;
  };
}
export const updateMeetingsLinkAction = createRequestAction(ActionTypes.MEETINGS_LINK_UPDATE_STARTED);
export const updateMeetingsLinkSucceeded = createRequestAction(ActionTypes.MEETINGS_LINK_UPDATE_SUCCEEDED,
// @ts-expect-error fix type after flux-actions has TypeScript support
response => MeetingsLink.fromId(response), () => createSuccessNotificationMeta(I18n.text('notifications.saveLinkSuccess')));
export const updateMeetingsLinkFailed = createRequestAction(ActionTypes.MEETINGS_LINK_UPDATE_FAILED, error => ({
  error
}), response => {
  let errorMessageKey = 'notifications.saveLinkError';
  if (response.responseText) {
    if (response.responseText.includes(LINK_OWNER_UPDATE_ERROR)) {
      errorMessageKey = 'notifications.saveTeammateLinkError';
    } else if (response.responseText.includes(PERSONAL_LINK_CREATE_ERROR)) {
      errorMessageKey = 'notifications.personalLinkEditError';
    } else if (response.responseText.includes(VCE_ACCOUNT_ID_ERROR)) {
      errorMessageKey = 'notifications.saveLinkVceAccountError';
    }
  }
  if (response.status === FORBIDDEN_ERROR_CODE) {
    errorMessageKey = 'notifications.editLinkPermissionsError';
  }
  return createDangerNotificationMeta(I18n.text(errorMessageKey));
});
export function updateMeetingsLink(meetingsLink, linkOwnerName, hideAlert) {
  return (dispatch, getState) => {
    dispatch(updateMeetingsLinkAction());
    const state = getState();
    const hasStarterFeatureAccess = getHasStarterFeatureAccess(state);
    if (!meetingsLink) {
      meetingsLink = getMeetingsLink(state);
    }
    if (!linkOwnerName) {
      linkOwnerName = getEditingLinkOwnerName(state);
    }
    const meetingsLinkAssociatedSettings = getMeetingsLinkAssociatedSettings(state);
    const currentMeetingsLinkAssociatedSettings = meetingsLinkAssociatedSettings.current;
    const meetingsLinkRequestBody = Object.assign({}, meetingsLink, {
      meetingsUserId: state.meetingsUser.id
    });
    const {
      customReminderEmail
    } = currentMeetingsLinkAssociatedSettings;
    const hasChangesToDefaultReminderEmail = !CustomReminderEmail.equalsJSON(customReminderEmail, buildDefaultReminderEmail(meetingsLink.customParams.includeDescriptionInReminder));
    const isUpdatingCustomMeetingReminders = hasStarterFeatureAccess && hasChangesToDefaultReminderEmail && !!(customReminderEmail.body && customReminderEmail.subject);
    const editingLinkOwnerUserId = meetingsLink.userId;
    const linkId = meetingsLink.id;
    const userId = getUserId(state);
    const editorIsOwner = editingLinkOwnerUserId === userId;
    const updateLinkRequest = editorIsOwner ? partial(updateMeetingsLinkRequest, meetingsLinkRequestBody) : partial(updateMeetingsLinkForUserRequest, meetingsLinkRequestBody, editingLinkOwnerUserId);
    const batchUpdateLinkRequests = [updateLinkRequest(), ...(isUpdatingCustomMeetingReminders ? [MeetingsCustomEmailActions.putCustomReminderEmail(linkId, customReminderEmail)(dispatch)] : [])];
    return Promise.allSettled(batchUpdateLinkRequests).then(results => {
      const rejectedResults = results.filter(result => result.status === 'rejected');
      if (rejectedResults.length) {
        dispatch(updateMeetingsLinkFailed(new Error(rejectedResults[0].reason.message)));
      } else {
        const response = results[0].value;
        if (!hideAlert) {
          FloatingAlertStore.addAlert({
            message: /*#__PURE__*/_jsx(FormattedMessage, {
              message: response.isDefaultLink ? response.userId === userId ? 'notifications.setDefaultSuccess' : 'notifications.setDefaultSuccessForUser' : 'notifications.saveLinkSuccess',
              options: {
                linkOwnerName
              }
            }),
            type: 'success'
          });
        }
        dispatch(updateMeetingsLinkSucceeded(response));
      }
    });
  };
}
export const deleteMeetingsLinkAction = createRequestAction(ActionTypes.MEETINGS_LINK_DELETE_STARTED);
export const deleteMeetingsLinkSucceeded = createRequestAction(ActionTypes.MEETINGS_LINK_DELETE_SUCCEEDED);
export const deleteMeetingsLinkFailed = createRequestAction(ActionTypes.MEETINGS_LINK_DELETE_FAILED, error => ({
  error
}));
export function deleteMeetingsLink(id, linkOwnerUserId, linkOwnerName) {
  return async (dispatch, getState) => {
    const state = getState();
    const userId = getUserId(state);
    const hasStarterFeatureAccess = getHasStarterFeatureAccess(state);
    dispatch(deleteMeetingsLinkAction());
    const deleteLinkRequest = linkOwnerUserId !== null && userId !== linkOwnerUserId ? partial(deleteMeetingsLinkForUserRequest, linkOwnerUserId, id) : partial(deleteMeetingsLinkRequest, id);
    if (!linkOwnerName) {
      linkOwnerName = getEditingLinkOwnerName(state);
    }
    let finalActionType = ActionTypes.MEETINGS_LINK_DELETE_FAILED;
    try {
      await deleteLinkRequest();
      FloatingAlertStore.addAlert({
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: userId === linkOwnerUserId ? 'notifications.deleteSuccess' : 'notifications.deleteSuccessForUser',
          options: {
            linkOwnerName
          }
        }),
        type: 'success'
      });
      dispatch(deleteMeetingsLinkSucceeded());
      finalActionType = ActionTypes.MEETINGS_LINK_DELETE_SUCCEEDED;
    } catch (error) {
      FloatingAlertStore.addAlert({
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "notifications.deleteFail"
        }),
        type: 'danger'
      });
      dispatch(deleteMeetingsLinkFailed(error));
      return finalActionType;
    }
    if (hasStarterFeatureAccess) {
      try {
        await MeetingsCustomEmailActions.deleteCustomReminderEmail(id)(dispatch);
      } catch (error) {
        Raven.captureException(new Error('Failed to delete custom reminder email after deleting meeting link'), {
          extra: {
            error
          }
        });
      }
    }
    return finalActionType;
  };
}
export const checkLinkSlugAction = createRequestAction(ActionTypes.MEETINGS_LINK_CHECK_SLUG_STARTED);
export const checkLinkSlugSucceeded = createRequestAction(ActionTypes.MEETINGS_LINK_CHECK_SLUG_SUCCEEDED, payload => payload);
export const checkLinkSlugFailed = createRequestAction(ActionTypes.MEETINGS_LINK_CHECK_SLUG_FAILED, error => ({
  error
}));
export function checkLinkSlug(namespace, slug) {
  const cleanedSlug = cleanSlug(slug);
  return dispatch => {
    dispatch(checkLinkSlugAction());
    return checkLinkSlugRequest(namespace, cleanedSlug).then(response => {
      dispatch(checkLinkSlugSucceeded(response));
    }, error => {
      dispatch(checkLinkSlugFailed(error));
    });
  };
}
export const transferMeetingsLinkAction = createRequestAction(ActionTypes.MEETINGS_LINK_TRANSFER_STARTED);
export const transferMeetingsLinkSucceeded = createRequestAction(ActionTypes.MEETINGS_LINK_TRANSFER_SUCCEEDED);
export const transferMeetingsLinkFailed = createRequestAction(ActionTypes.MEETINGS_LINK_TRANSFER_FAILED, error => ({
  error
}));
function transferLink(linkIds, fromHubspotUserId, toHubspotUserId) {
  return dispatch => {
    dispatch(transferMeetingsLinkAction());
    return transferMeetingsLinkRequest({
      fromHubspotUserId,
      toHubspotUserId,
      linkIds
    }).then(() => {
      FloatingAlertStore.addAlert({
        'data-test-id': 'transfer-success-alert',
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "notifications.transferSuccess"
        }),
        type: 'success'
      });
      UsageTracker.track('meetingLink', {
        action: 'transfer'
      });
      dispatch(transferMeetingsLinkSucceeded());
      dispatch(fetchMeetingsLinks(fromHubspotUserId));
    }, error => {
      let errorMessage = /*#__PURE__*/_jsx(FormattedMessage, {
        message: 'notifications.transferFail'
      });
      if (error.status === FORBIDDEN_ERROR_CODE) {
        errorMessage = /*#__PURE__*/_jsx(FormattedMessage, {
          message: 'notifications.transferFailPermission',
          options: {
            failedReason: error.responseJSON.message
          }
        });
      }
      FloatingAlertStore.addAlert({
        message: errorMessage,
        type: 'danger'
      });
      dispatch(transferMeetingsLinkFailed(error));
      UsageTracker.track('meetingLink', {
        action: 'transfer fail'
      });
    });
  };
}
function transferAndUpdateLink(linkIds, fromHubspotUserId, toHubspotUserId, linkIdsToUpdate, isEditView) {
  return (dispatch, getState) => {
    return dispatch(transferLink(linkIds, fromHubspotUserId, toHubspotUserId)).then(() => {
      if (isEditView) {
        const editedLinkId = linkIdsToUpdate[0];
        return dispatch(fetchMeetingsLinkById(editedLinkId)).then(() => {
          dispatch(setMeetingsLinkIgnoredPropertiesMap({
            customParams: ['location', 'videoConferenceExtensionAppId', 'videoConferenceExtensionAccountId'],
            meetingsLink: []
          }));
          const state = getState();
          const meetingsLink = getMeetingsLink(state);
          const meetingsLinkCustomParams = meetingsLink.customParams;
          const updatedMeetingsLink = Object.assign({}, meetingsLink, {
            customParams: Object.assign({}, meetingsLinkCustomParams, {
              location: '',
              videoConferenceExtensionAccountId: null,
              videoConferenceExtensionAppId: null
            })
          });
          const linkOwnerName = null;
          const hideSaveAlertToast = true;
          return dispatch(updateMeetingsLink(updatedMeetingsLink, linkOwnerName, hideSaveAlertToast));
        });
      } else {
        return dispatch(fetchMeetingsLinks(toHubspotUserId)).then(() => {
          const state = getState();
          const meetingsLinks = state.meetingsLinks;
          return linkIdsToUpdate.map(id => {
            const linkToUpdate = meetingsLinks.find(link => link.id === id);
            if (linkToUpdate) {
              const linkToUpdateJSON = linkToUpdate.convertToJSON();
              const meetingsLinkCustomParams = linkToUpdateJSON.customParams;
              const updatedMeetingsLink = Object.assign({}, linkToUpdateJSON, {
                customParams: Object.assign({}, meetingsLinkCustomParams, {
                  location: '',
                  videoConferenceExtensionAccountId: null,
                  videoConferenceExtensionAppId: null
                })
              });
              const linkOwnerName = null;
              const hideSaveAlertToast = true;
              return dispatch(updateMeetingsLink(updatedMeetingsLink, linkOwnerName, hideSaveAlertToast));
            }
            return dispatch(fetchMeetingsLinks(fromHubspotUserId));
          });
        });
      }
    });
  };
}
export function transferMeetingsLink(linkIdsToTransfer, fromHubspotUserId, toHubspotUserId, linkIdsToUpdate = [], isEditView) {
  const linkIds = linkIdsToTransfer.toJS();
  return dispatch => {
    if (linkIdsToUpdate.length) {
      return dispatch(transferAndUpdateLink(linkIdsToTransfer, fromHubspotUserId, toHubspotUserId, linkIdsToUpdate, isEditView));
    }
    return dispatch(transferLink(linkIds, fromHubspotUserId, toHubspotUserId));
  };
}